export enum UploadStatus {
    WAITING = 1,
    UPLOADING = 2,
    COMPLETED = 3,
  }
